import * as React from 'react';
import styled from 'styled-components';
import { keyMetricsSettingsProvider } from '../../../data/providers/settings/keyMetricsSettingsProvider';
import {
  IKeyMetricsMap,
  ISelectableTestType,
  ISelectOption,
} from '../../../data/types';
import { updateKeyMetrics } from '../../../data/writers/settings';
import { ControlLabel } from '../../shared/form/ControlLabel';
import { SingleMetricSelect } from '../../shared/form/selects/SingleMetricSelect';

interface IProps {
  activeTestType: ISelectableTestType;
}

const KeyMetric = (props: IProps): React.ReactElement => {
  const [keyMetrics, setKeyMetrics] = React.useState<IKeyMetricsMap>({});

  const onKeyMetricChange = (s: ISelectOption): Promise<void> =>
    updateKeyMetrics(props.activeTestType.value, s);

  React.useEffect((): (() => void) => {
    const subscriber = keyMetricsSettingsProvider().subscribe(
      (mKeyMetrics: IKeyMetricsMap): void => {
        setKeyMetrics(mKeyMetrics);
      }
    );
    return (): void => subscriber.unsubscribe();
  }, []);

  const metric =
    props.activeTestType && keyMetrics && keyMetrics[props.activeTestType.value]
      ? keyMetrics[props.activeTestType.value]
      : null;

  return (
    <React.Fragment>
      <ControlLabel>Key Metric</ControlLabel>
      <SingleMetricSelect
        onChange={onKeyMetricChange}
        value={metric}
        disabled={!props.activeTestType}
        testTypeId={props.activeTestType ? props.activeTestType.value : null}
      />
      <MetricDatabaseLink
        href='https://www.hawkindynamics.com/hawkin-metric-database'
        target='_blank'
        rel='noopener noreferrer'
      >
        Learn more about metrics in our database
      </MetricDatabaseLink>
    </React.Fragment>
  );
};

const MetricDatabaseLink = styled.a`
  margin-top: 8px;
  color: var(--color-accent);
  font-size: 0.9em;

  &:hover {
    text-decoration: underline;
  }
`;

export { KeyMetric };
